<template>
  <b-form class="registration" @submit="handleEmail">
    <b-form-group class="registration__input p-3">
      <b-form-input
        v-model="email"
        @keydown.enter="handleEmail"
        type="email"
        placeholder="Entrez votre adresse e-mail"
        required
      ></b-form-input>

      <div class="input__error" v-if="!$v.email.required">Le champ est requis.</div>
      <div class="input__error" v-if="!$v.email.email">Votre e-mail doit être valide.</div>

      <div class="text-center mt-4">
        <b-button @click="handleEmail" variant="success">Démarrer ma lecture</b-button>
      </div>
    </b-form-group>
  </b-form>
</template>

<script>
import { BForm, BFormGroup, BFormInput, BButton } from "bootstrap-vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "Email",
  mixins: [validationMixin],
  components: { BForm, BFormGroup, BFormInput, BButton },
  data: () => ({
    email: null,

    errorMessage: null,
    hasSubmitError: false,
  }),
  methods: {
    handleEmail(e) {
      if (e) e.preventDefault();

      this.$v.$touch();

      if (this.$v.$invalid) return;

      const { email } = this;
      this.$emit("success", email);
    },
  },
  validations: {
    email: {
      required,
      email,
    },
  },
};
</script>
